import { render, staticRenderFns } from "./dashboard-container-item.vue?vue&type=template&id=7fa6bc97&scoped=true"
import script from "./dashboard-container-item.vue?vue&type=script&lang=js"
export * from "./dashboard-container-item.vue?vue&type=script&lang=js"
import style0 from "./dashboard-container-item.vue?vue&type=style&index=0&id=7fa6bc97&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa6bc97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fa6bc97')) {
      api.createRecord('7fa6bc97', component.options)
    } else {
      api.reload('7fa6bc97', component.options)
    }
    module.hot.accept("./dashboard-container-item.vue?vue&type=template&id=7fa6bc97&scoped=true", function () {
      api.rerender('7fa6bc97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/dashboard-container/dashboard-container-item.vue"
export default component.exports